export default "__VITE_ASSET__ECzfp$oh__"